import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GeneralService } from '@app/core/services/general.service';
import { ProductOption } from '@app/shared/enums/enums';
import { CheckboxInputComponent } from '../checkbox-input/checkbox-input.component';
import { MobileNumberInputComponent } from '../mobile-number-input/mobile-number-input.component';
import { TextInputComponent } from '../text-input/text-input.component';

export interface CustomerInterestData {
  name: string;
  mobile: number;
  company: string;

  interestGgbs: boolean;
  interestGfrp: boolean;
  interestBitumen: boolean;
}

@Component({
  selector: 'app-show-interest',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    ReactiveFormsModule,
    TextInputComponent,
    MobileNumberInputComponent,
    CheckboxInputComponent,
  ],
  templateUrl: './show-interest.component.html',
  styleUrl: './show-interest.component.scss',
})
export class ShowInterestComponent implements OnInit {
  product: ProductOption;

  interestForm: FormGroup;

  isFormSubmitted: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ShowInterestComponent>,
    private generalService: GeneralService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.product = data.product;

    this.interestForm = this.fb.group({
      name: [{ value: null, disabled: false }, Validators.required],
      mobile: [{ value: null, disabled: false }, Validators.required],
      company: [{ value: null, disabled: false }, Validators.required],

      interestGgbs: [{ value: this.product == ProductOption.EKO_BLEND, disabled: false }],
      interestGfrp: [{ value: this.product == ProductOption.EKO_BAR, disabled: false }],
      interestBitumen: [{ value: this.product == ProductOption.TAR_SHAKIT, disabled: false }],
    });
  }

  ngOnInit(): void {}

  onSubmit(): void {
    let mutationData: CustomerInterestData = {
      name: this.interestForm.get('name')!.value,
      mobile: this.interestForm.get('mobile')!.value,
      company: this.interestForm.get('company')!.value,

      interestGgbs: this.interestForm.get('interestGgbs')!.value,
      interestGfrp: this.interestForm.get('interestGfrp')!.value,
      interestBitumen: this.interestForm.get('interestBitumen')!.value,
    };

    this.generalService.postApiCustomerInterestRegistration(mutationData).subscribe((response) => {
      this.isFormSubmitted = true;
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
